import React from 'react';

import Header from './partials/Header';

import Banner from './homepage/Banner';
import Selfcare from './homepage/Selfcare';
import SkinStories from './homepage/SkinStories';
import ElevatedIngredient from './homepage/ElevatedIngredient';
import Video from './homepage/Video';
import Personalised from './homepage/Personalised';
import Brands from './partials/Brands';
import Gallery from './homepage/Gallery';
import InstaGallery from './homepage/InstaGallery';

import Footer from './partials/Footer';

function App() {
  return (
    <div className="App">
        <Header type="homepage"/>
            <Banner />
            <Selfcare />
            <SkinStories />
            <ElevatedIngredient />
            <Video />
            <Personalised />
            <Brands />
            <Gallery />
            <InstaGallery />
        <Footer />
    </div>
  );
}

export default App;
